module.exports = __webpack_public_path__ + "static/bernardov2-e38e4eebdfcd161456fea16df1564f98.jpg";